import { AnimatedTransitionCard } from "@package/ui-components";
import {
  type AnimationOption,
  type AnimationWipeFunction,
} from "@package/ui-gql/index-data-access";
import { type ReactNode, useEffect, useMemo, useState } from "react";

type AnimationOptionWipePreviewProps = {
  fn: AnimationWipeFunction;
};

export function AnimationOptionWipePreview({
  fn,
}: AnimationOptionWipePreviewProps) {
  const animation = useMemo<AnimationOption>(
    () => ({
      __typename: "AnimationOptionWipe",
      type: "wipe",
      duration: 1,
      function: fn,
    }),
    [fn],
  );
  const componentA = useMemo(
    () => <div className="absolute w-full h-full bg-sky-500" />,
    [],
  );
  const componentB = useMemo(
    () => <div className="absolute w-full h-full bg-green-500" />,
    [],
  );

  const [node, setNode] = useState<ReactNode>(componentA);
  const [nodeId, setNodeId] = useState<string>("a");

  useEffect(
    function effectAnimationOptionWipePreviewTimer() {
      const timeout = setInterval(() => {
        setNode((prev) => (prev === componentA ? componentB : componentA));
        setNodeId((prev) => (prev === "a" ? "b" : "a"));
      }, 2000);

      return () => {
        clearInterval(timeout);
      };
    },
    [componentA, componentB],
  );

  return (
    <div className="relative w-24 h-24 m-4 shadow-lg border border-slate-400">
      <AnimatedTransitionCard
        animation={animation}
        node={node}
        nodeId={nodeId}
      />
    </div>
  );
}
